import type { LucideIcon } from 'lucide-react';
import { BookOpen, Briefcase, CalendarDays, ChartColumn, Factory, House, MessagesSquare, Plug, Settings, Users, Wallet, Contact, Workflow } from 'lucide-react';
import type { MenuPrincipal } from '@malgoos/shared';

/** F5: só menus principais, gerados deste array e filtrados por permissão e módulo instalado. */
export const MENUS: { chave: MenuPrincipal; icone: LucideIcon; tour?: string }[] = [
  { chave: 'inicio', icone: House },
  { chave: 'cadastros', icone: Contact },
  { chave: 'comercial', icone: Briefcase },
  { chave: 'financeiro', icone: Wallet },
  // Fase 2 (W31): Relatórios em item próprio, logo depois do Financeiro.
  { chave: 'relatorios', icone: ChartColumn },
  { chave: 'agenda', icone: CalendarDays },
  { chave: 'pessoas', icone: Users },
  { chave: 'operacao', icone: Factory },
  { chave: 'comunicacao', icone: MessagesSquare },
  { chave: 'treinamento', icone: BookOpen },
  { chave: 'integracoes', icone: Plug },
  // FUN 2026-10-15 (U7): Automações (robôs do servidor Windows), antes do Admin, no lugar do item fixo do B8.
  { chave: 'automacoes', icone: Workflow },
  { chave: 'admin', icone: Settings, tour: 'menu-admin' },
];
